'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.loadGoals = loadGoals;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */

var LOAD = 'LOAD';
var LOAD_FAIL = 'LOAD_FAIL';
var LOAD_GOALS = 'LOAD_GOALS';

var initialState = {
  loaded: false,
  updating: false,
  updateError: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        updating: true
      });
    case LOAD_GOALS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        'goals': action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loaded: false
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.admin && globalState.admin.loaded;
}

function loadGoals() {
  return {
    types: [LOAD, LOAD_GOALS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/admin/getGoals');
    }
  };
}
/* eslint-enable */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/adminGoals.js
// module id = 516
// module chunks = 0